export default __webpack_public_path__ + "578c356187ff1c09845d9145c4b02ee3.png";